import React from 'react'
import Highcharts from 'highcharts'
import HT from 'highcharts/modules/timeline'
import HighchartsReact from 'highcharts-react-official'
import Spinner from '../Loader/Spinner'
import getColumnChartOptions from './getColumnChartOptions'
import getAgeGenderColumnChartOptions from './getAgeGenderColumnChartOptions'
import styles from './ColumnChartDisplay.module.scss'

if (typeof Highcharts === 'object') {
  HT(Highcharts)
}

const BarChartDisplay = ({ data, chartName,renderType,locationName,displayDate }) => {
  let categories = []
  let graph_female_data = []
  let graph_male_data = []
  const finalData = []
  if (chartName === 'genderAgechart') {
   

    let res = data[0] //JSON.parse(data)
  res.map((data_val) => {
    categories.push(data_val.age_bucket_display)
    graph_female_data.push({name:data_val.age_bucket_display,y:data_val.female_count<=-1?0:data_val.female_count})
    graph_male_data.push({name:data_val.age_bucket_display,y:data_val.male_count<=-1?0:data_val.male_count})
  })

  finalData.push({ name: 'category', data:categories })
  finalData.push({ name: 'Male', data: graph_male_data })
  finalData.push({ name: 'Female', data: graph_female_data })
   
  }
  

  //dummy data
  const chartOptions =getAgeGenderColumnChartOptions(finalData,renderType,chartName,locationName,displayDate)

  return chartOptions ? (
    <div className={styles.base}>
      <div className={styles.body}>
        <HighchartsReact
          containerProps={{
            style: {
              height: '100%',
              width: '100%',
              position: 'relative',
            },
          }}
          highcharts={Highcharts}
          options={chartOptions}
          allowChartUpdate
           updateArgs={[true, true, true]}
        />
      </div>
    </div>
  ) : (
    <Spinner />
  )
}

export default BarChartDisplay
